import { render, staticRenderFns } from "./UpdateUserInfoWealthDialog.vue?vue&type=template&id=95cd0df0&scoped=true&lang=pug&"
import script from "./UpdateUserInfoWealthDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserInfoWealthDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateUserInfoWealthDialog.vue?vue&type=style&index=0&id=95cd0df0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cd0df0",
  null
  
)

export default component.exports